const namespaced = true;

const defaultState = () => {
  return {
    tags: [],
    add: false,
    edit: false,
    remove: false,
    selectedTag: {},
    loading: false,
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  SET_ADD(state, add) {
    state.add = add;
  },
  SET_ADD_TAG(state, tag) {
    state.tags = [...state.tags, tag];
  },
  SET_REMOVE(state, remove) {
    state.remove = remove;
  },
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  REMOVE_TAG(state, id) {
    const index = state.tags.findIndex((item) => item.id === id);
    index !== -1 ? state.tags.splice(index, 1) : "";
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  UPDATE_TAG(state, tag) {
    const index = state.tags.findIndex((item) => item.id === tag.id);
    index !== -1 ? state.tags.splice(index, 1, tag) : "";
  },
  SET_SELECTED_TAG(state, selectedTag) {
    state.selectedTag = selectedTag;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
